import React, { useState } from 'react';
import { Button, Form, Input, Select, ConfigProvider, Table, message } from 'antd';
import { useEffect } from 'react';
import axios from 'axios';
import { rangeOptions, tableColumns } from './const'
import request from '../../../utils/request';
import qs from 'qs'
import { oneSixSixRequestAddress } from '../../config'

export default function SubShips() {
    const [form] = Form.useForm();
    const [typeOptions, setTypeOptions] = useState([])
    const [countryOptions, setCountryOptions] = useState([])
    const [tableData, setTableData] = useState([])
    const [total, setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(20)
    const [pageNum, setPageNum] = useState(1)
    const [loading, setLoading] = useState(false);
    const [checkedRows, setCheckedRows] = useState([])
    const [checkedRowKeys, setCheckedRowKeys] = useState([])
    
    const token = localStorage.getItem('token')

    useEffect(() => {
        axios.get(`${oneSixSixRequestAddress}/portrait/targets/countryList`).then((res) => {
            setCountryOptions(res.data)
        })
        axios.get(`${oneSixSixRequestAddress}/portrait/targets/typeList`).then((res) => {
            setTypeOptions(res.data)
        })
        request({
            url: `${oneSixSixRequestAddress}/portrait/targets/list`,
            params: {
                findRange: 'subscribed'
            },
            headers: {
                'Authorization': token,
            },
            method: 'get',
        }).then(res => {
            setCheckedRows(res.rows)
            setCheckedRowKeys(res.rows.map(item => item.id))
        })
        const values = form.getFieldsValue()
        getList(values, 1)
    }, [])

    const onReset = () => {
        form.resetFields();
    };
    
    const onFinish = (values) => {
        getList(values, 1)
    };

    const getList = (values, pageNum) => {
        const params = getParams(values)
        setLoading(true)
        request({
            url: `${oneSixSixRequestAddress}/portrait/targets/list`,
            params: {
                ...params,
                pageNum,
                pageSize,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            },
            headers: {
                'Authorization': token,
            },
            method: 'get',
        }).then(res => {
            setTableData(res.rows)
            setTotal(res.total)
            setPageNum(pageNum)
            setLoading(false)
        }).catch(res => {
            setLoading(false)
        })
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const getParams = (values) => {
        let params = {}
        const { locCountrys, opprops, findRange, keyWord } = values
        params.locCountrys = locCountrys
        params.opprops = opprops
        params.findRange = findRange
        params.chnName = keyWord
        params.engName = keyWord
        return params
    }

    const handleOnPageChange = (current) => {
        setPageNum(current)
        const values = form.getFieldsValue()
        getList(values, current)
    }

    const handleOnShowSizeChange = (current, size) => {
        setPageSize(size)
        const values = form.getFieldsValue()
        getList(values, 1)
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setCheckedRowKeys(selectedRowKeys)
            const validRows = selectedRows.filter(item => item)
            const subscribedRows = selectedRowKeys.map(key => (
                checkedRows.find((row) => row.id === key)
                || validRows.find((row) => row.id === key)  // 必在两者之中
            ))
            if(selectedRowKeys.length === validRows.length)
                setCheckedRows(selectedRows)
            else
            setCheckedRows(subscribedRows)
        },
        preserveSelectedRowKeys: true,
        selectedRowKeys: checkedRowKeys,
        selectedRows: checkedRows
    };

    const sentSubscribe = () => {
        request({
            url: `${oneSixSixRequestAddress}/portrait/targets/subscribe`,
            method: 'post',
            data: checkedRows,
            headers: {
                'Authorization': token,
            },
        }).then(res => {
            message.success(res.msg)
            form.resetFields();
            const values = form.getFieldsValue()
            getList(values, 1)
        }).catch(err => {
            message.error(err.msg ? err.msg : '发生未知错误')
        })
    }

    return (
        <div className="sub-ships-box gap">
            <div className="sub-title">设施目标</div>
            <Form
                className="form"
                layout='inline'
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Form.Item label="所属国家" name="locCountrys">
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="Please select"
                        defaultValue={[]}
                        options={countryOptions}
                    />
                </Form.Item>
                <Form.Item label="类型" name="opprops">
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="Please select"
                        defaultValue={[]}
                        options={typeOptions}
                    />
                </Form.Item>
                <Form.Item label="查看范围" name="findRange">
                    <Select
                        allowClear
                        placeholder="Please select"
                        options={rangeOptions}
                    />
                </Form.Item>
                <Form.Item name="keyWord">
                    <Input placeholder="请输入关键词"/>
                </Form.Item>
                <Form.Item>
                    <ConfigProvider autoInsertSpaceInButton={false}>
                        <Button type="primary" htmlType="submit" className="submit">搜索</Button>
                        <Button htmlType="button" onClick={onReset} className="reset" >
                            重置
                        </Button>
                    </ConfigProvider>
                </Form.Item>
            </Form>
            <Button className="sentSubButton" onClick={sentSubscribe}>提交订阅</Button>
            <Table
                loading={loading}
                className="table"
                rowSelection={{
                    type: 'checkbox',
                    ...rowSelection,
                }}
                columns={tableColumns}
                dataSource={tableData}
                scroll={{y: "calc(100vh - 350px)"}}
                pagination={{
                    showTotal: () => `共${total}条`,
                    onChange: handleOnPageChange,
                    onShowSizeChange: handleOnShowSizeChange,
                    total,
                    current: pageNum,
                    pageSize,
                }}
                rowKey={record => record.id}
            />

        </div>
    )
}